export default "__VITE_ASSET__B1oYKs6J__"